'use client';

import { Portal, Drawer } from 'components/pcc-components';
import { ROOT_PORTALS } from 'constants/targets';
import { useAssociatedDealer } from 'components/associated-dealers/associated-dealer-context';
import { SelectCustomerForm } from '../select-customer-form/select-customer-form';
import { DealerSearchForm } from '../dealer-search-form/dealer-search-form';
import { SearchResultsForm } from '../search-results-form/search-results-form';
import { LocationAddress } from 'services/location/types';
import { useAssociatedDealerForms } from 'components/associated-dealers/hooks/use-associated-dealer-forms';
import { DealerResponse } from 'services/dealer';
import { DealerAssociationResponse } from 'services/dealer-association';

type AssociatedDealerDrawerContentProps = {
  isLoggedIn: boolean;
  isDealerUser: boolean;
  isInstantAccessUser: boolean;
  isCspUser: boolean;
  dealerUserResponse: DealerResponse;
  registeredUserResponse: DealerAssociationResponse;
  storeAddress: LocationAddress;
};

export const AssociatedDealerDrawerContent = ({
  isDealerUser,
  isInstantAccessUser,
  isCspUser,
  isLoggedIn,
  dealerUserResponse,
  registeredUserResponse,
  storeAddress
}: AssociatedDealerDrawerContentProps) => {
  const { associatedDealerDrawer, searchResultsDrawer, selectCustomerDrawer } =
    useAssociatedDealer();
  const { dealerSearchForm, searchResultsForm, selectCustomerForm } =
    useAssociatedDealerForms();

  return (
    <Portal id={ROOT_PORTALS}>
      {isDealerUser ? (
        <>
          <Drawer {...associatedDealerDrawer?.drawerProps}>
            <DealerSearchForm
              dealerSearchForm={dealerSearchForm}
              dealerUserResponse={dealerUserResponse}
            />
          </Drawer>
          <Drawer {...searchResultsDrawer?.drawerProps}>
            <SearchResultsForm searchResultsForm={searchResultsForm} />
          </Drawer>
          <Drawer {...selectCustomerDrawer?.drawerProps}>
            <SelectCustomerForm
              dealerSearchForm={dealerSearchForm}
              selectCustomerForm={selectCustomerForm}
              isDealerUser={isDealerUser}
              isInstantAccessUser={isInstantAccessUser}
              isCspUser={isCspUser}
              isLoggedIn={isLoggedIn}
              dealerUserResponse={dealerUserResponse}
              registeredUserResponse={registeredUserResponse}
              storeAddress={storeAddress}
              showPricingWarning={true}
            />
          </Drawer>
        </>
      ) : (
        <Drawer {...associatedDealerDrawer?.drawerProps}>
          <SelectCustomerForm
            dealerSearchForm={dealerSearchForm}
            selectCustomerForm={selectCustomerForm}
            isDealerUser={isDealerUser}
            isInstantAccessUser={isInstantAccessUser}
            isCspUser={isCspUser}
            isLoggedIn={isLoggedIn}
            dealerUserResponse={dealerUserResponse}
            registeredUserResponse={registeredUserResponse}
            storeAddress={storeAddress}
            showPricingWarning={true}
          />
        </Drawer>
      )}
    </Portal>
  );
};
